import { selectEntityStatus } from "../ui/ui.selectors";
import { GENERATOR_PRODUCTS } from "./generator-products.reducer";

export const selectGeneratorProducts = (state) => state[GENERATOR_PRODUCTS];
export const selectGeneratorProductsItems = (state) => state[GENERATOR_PRODUCTS].items;
export const selectGeneratorProductsSessionId = (state) => state[GENERATOR_PRODUCTS].sessionId;
export const selectGeneratorProductsPrevious = (state) => state[GENERATOR_PRODUCTS].previous;
export const selectGeneratorProductsStatus = (state) => selectEntityStatus(state, GENERATOR_PRODUCTS);
